import {
  Breadcrumbs,
  Grid,
  Link,
  TextField,
} from "@mui/material";
import { useEffect, useState } from "react";
import Styles from "../styles/main.module.css";
import TrackerTable from "./TrackerTable";
import logo from "../../../../images/Group 1000000833.png";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { useStateValue } from "../../../../Hooks/stateProvider";
import Loader from "../../../../Loader/Loader";
import { ls } from "../../../../variables";
import { encrypt } from "../../../../utils/cipher";
import { Box } from "@mui/system";
import FilterList from "../../../../components/FilterList";
import { previewValidators } from "../../../../utils/validators";
import SelectComponent from "../../../../components/SelectComponent";
import { errorHandler } from "../../../../utils/errorHandling";
const TrackerPage = () => {

  const pmsName = ls.get("pmsName");
  const navigate = useNavigate();
  const [{ pageLoading, moduleType, fy_year, quarter }, dispatch] = useStateValue();
  const [selectedFinancialYear, setSelectedFinancialYear] = useState(fy_year);
  const [selectedQuarterly, setSelectedQuarterly] = useState(quarter);
  const [selectedGuidanceType, setSelectedGuidanceType] = useState([]);
  const [guidanceTypeOptions, setGuidanceTypeOptions] = useState();
  const [receivedData, setReceivedData] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [rows, setRows] = useState([]);

  const [openselectBox, setOpenselectBox] = useState(false);
  const [openNestedList, setOpenNestedList] = useState({
    "localCMMTypeData": ["Compliance Reporting Category 1"],
    "localRemarksData": [],
    "localStatusData": ["open", "pending"],
    "localGuidanceData": []
  })
  const [filteredRows, setFilteredRows] = useState(rows);
  const [dataFetchFlag, setDataFetchFlag] = useState(false);
  const type = moduleType;

  const getFilteredData = (element) => {
    setFilteredRows(rows.filter((val) => {
    if(element){
      const hasGuidanceData = element["localGuidanceData"].length !== 0;
      const hasStatus = element["localStatusData"].length !== 0;

      return(
        (!hasGuidanceData || element["localGuidanceData"]?.includes(val.guidance_type)) &&
            (!hasStatus || element["localStatusData"]?.includes(val.alert_status))
      )
    }
      if (openNestedList["localStatusData"].length == 0 && openNestedList["localGuidanceData"].length == 0) {
        return true;
      } else if (openNestedList["localStatusData"].length != 0 && openNestedList["localGuidanceData"].length != 0) {
        return openNestedList["localStatusData"].includes(val.alert_status) && openNestedList["localGuidanceData"].includes(val.guidance_type);
      } else {
        return openNestedList["localStatusData"].includes(val.alert_status) || openNestedList["localGuidanceData"].includes(val.guidance_type) 
      }
    }));
  }

  const handlePreviewClick = async () => {
    if (previewValidators(selectedFinancialYear, selectedQuarterly, false, "", dispatch, pmsName)) {
      dispatch({ type: "SHOW_LOADER" });
      const payload = {
        fy_year: selectedFinancialYear,
        quarter: selectedQuarterly,
        pmsName: pmsName,
        moduleType: moduleType,
        userType: ls.get("userType"),
        authToken: ls.get("authToken"),
        refreshToken: ls.get("refreshToken")
      };
      const encryptedPayload = await encrypt(payload)
      axios
        .post("/api/pms/trackerPageFetchAPI", { payload: encryptedPayload }, {
          withCredentials: true
        })
        .then((tableData) => {
          const GToptions = tableData.data.gudianceTypeArr;
          const data = tableData.data.data;
          // console.log("data value", data)
          setGuidanceTypeOptions(GToptions);
          setReceivedData(data);
          setRows(data);
          dispatch({ type: "totalClosed", totalClosed: data.length });
          setFilteredRows(data.filter((val) => {
            if (openNestedList["localStatusData"].length == 0 && openNestedList["localGuidanceData"].length == 0) {
              return true;
            } else if (openNestedList["localStatusData"].length != 0 && openNestedList["localGuidanceData"].length != 0) {
              return openNestedList["localStatusData"].includes(val.alert_status) && openNestedList["localGuidanceData"].includes(val.guidance_type);
            } else {
              return openNestedList["localStatusData"].includes(val.alert_status) || openNestedList["localGuidanceData"].includes(val.guidance_type);
            }
          }));
          dispatch({
            type: "PMSTrackerData",
            PMSTrackerData: {
              fy_year: selectedFinancialYear,
              quarter: selectedQuarterly,
            },
          });

          dispatch({
            type: "CMMTrackerData",
            CMMTrackerData: {
              fy_year: selectedFinancialYear,
              quarter: selectedQuarterly,

            }
          })
          // dispatch({ type: "totalClosed", totalClosed: receivedData.length });
          dispatch({ type: "HIDE_LOADER" });
          setDataFetchFlag(true);
        })
        .catch((err) => {
          dispatch({ type: "HIDE_LOADER" });
          errorHandler(err, navigate)
        });
    }
  };
  
  useEffect(() => {
    if (fy_year != "" && quarter != "") {
      handlePreviewClick()
    }
  }, []);

  useEffect(() => {
    setReceivedData([]);
    dispatch({ type: "fy_year", fy_year: selectedFinancialYear });
    dispatch({ type: "quarter", quarter: selectedQuarterly });
    // dispatch({ type: "totalClosed", totalClosed: receivedData.length });
  }, [selectedFinancialYear, selectedQuarterly]);

  const handleSearch = (event) => {
    const query = event.target.value;
    setSearchQuery(query);
    const filteredData = receivedData.filter((row) => {
      const { fy_year, quarter, pmsName, alert_remarks, sebi_remarks, instance_count, ...rest } = row;
      return Object.values(rest).some((val) =>
        val?.toString().toLowerCase().includes(query.toLowerCase())
      );
    });
    setFilteredRows(filteredData);
  };

  return (
    <>
      <div className={Styles.FullBody}>
        <div className={Styles.navBody}>
          <Breadcrumbs className={Styles.historyNav} aria-label="breadcrumb">
            {/* {ls.get("userType") != "RTA" && */}
              <Link
                underline="hover"
                color="inherit"
                onClick={() => navigate("/app/welcome")}
              >
                Welcome
              </Link>
              {/* } */}
            <Link
              underline="hover"
              color="inherit"
            >
              Tracker
            </Link>
          </Breadcrumbs>
          {receivedData.length > 0 && <TextField
            style={{
              height: "2rem",
              width: "clamp(10rem,20vw,30rem)",
            }}
            variant="outlined"
            placeholder="Search Table"
            value={searchQuery}
            onChange={handleSearch}
          />}
        </div>
        <div className={Styles.HeaderBody}>
          <div>
            <Grid container spacing={2} display="flex">
              <Grid item
                xs={12}
                sm={12}
                md={9}
                lg={9}>
                <SelectComponent
                  selectedFinancialYear={selectedFinancialYear}
                  setSelectedFinancialYear={setSelectedFinancialYear}
                  selectedQuarter={selectedQuarterly}
                  setSelectedQuarter={setSelectedQuarterly} />
              </Grid>
              <Grid
                item
                xs={12}
                sm={6}
                md={3}
                lg={3}
                className={Styles.dataFormButtonTracker}
                style={{
                  display: "flex",
                  alignItems: "end",
                  justifyContent: "flex-end"
                }}
              >
                <button className={Styles.Preview} onClick={handlePreviewClick}>
                  APPLY
                </button>
                {rows.length != 0 && <button className={Styles.Preview} style={{ marginLeft: "1rem" }} onClick={(e) => {
                  e.stopPropagation()
                  setOpenselectBox(true)
                }}>
                  FILTER
                </button>}
                {openselectBox && (
                  <Box

                    sx={{
                      bgcolor: "background.paper",
                      width: { xs: "35%", md: "30%", lg: "28%" },
                      position: "absolute",
                      right: { xs: "1.2rem", md: "2rem" },
                      backgroundColor: "white",
                      zIndex: "100",
                      boxShadow: 6,
                      marginTop: "0.5rem",
                      borderRadius: "1rem",
                      top: "13rem"
                    }
                    }
                  >

                    <FilterList handleOpen={setOpenselectBox} open={openselectBox} openNestedList={openNestedList} setOpenNestedList={setOpenNestedList} fetchData={getFilteredData} moduleType={type} guidanceTypeOptions={guidanceTypeOptions} />
                  </Box>)}
              </Grid>
            </Grid>
          </div>
        </div>
        <div className={Styles.tableBody}>
          {!dataFetchFlag && <Loader />}
          {dataFetchFlag && (<TrackerTable GTtype={selectedGuidanceType} tableData={filteredRows} handlePreviewClick={handlePreviewClick} />)}
          {(pageLoading == false || pageLoading == undefined) && !dataFetchFlag && (
            <img
              className="image"
              src={logo}
              alt="MainImage"
            />
          )}
        </div>
      </div>
    </>
  );
};

export default TrackerPage;
